export default __webpack_public_path__ + "static/media/tc.f74ae43b.svg";